import endpoints from '@/api/endpoints';
import { http, HttpResponse } from 'msw';

const API_BASE_URL = endpoints.baseURL;

export const mockAccounts = [
  {
    accountId: '0b679eab-db5e-4cb4-b07e-2a8185bb2757',
    name: 'FARHA IMPORT AND EXPORT CO LTD',
    displayed: true,
    hidden: false,
    accountNumber: '00010804501-75',
    account: {
      currency: { id: '2d0a7522-7e01-44ae-b387-3033bafd5cf5', alphabeticCode: 'USD' },
      balanceInReferenceCurrency: 82.33,
      branchCode: '0001',
    },
    minBalanceLimit: 100,
  },
  {
    accountId: '69474838-f0cd-497d-b21b-d8994e1034d0',
    name: 'FARHA IMPORT AND EXPORTE CO LTD',
    displayed: true,
    hidden: false,
    accountNumber: '00010804501-67',
    account: {
      currency: { id: '23bef168-362c-4f94-b37e-b0f7c4adc455', alphabeticCode: 'SSP' },
      balanceInReferenceCurrency: 97732.71,
      branchCode: '0001',
    },
    minBalanceLimit: 100,
  },
];

// Two SSP accounts — used for between-accounts (same currency) transfer tests
export const mockSspAccounts = [
  mockAccounts[1],
  { ...mockAccounts[0], account: { ...mockAccounts[0].account, currency: { id: 'ssp-id', alphabeticCode: 'SSP' } } },
];

export const mockCurrentUser = {
  id: '13be585d-e25e-45fc-a244-3d566b470eb2',
  firstName: 'FARHA IMPORT AND EXPORT CO LTD',
  lastName: 'FIECL',
  username: 'farhaimportexport66',
  phone: '+211919205015',
  email: 'farha-import-export@yopmail.com',
  mfaEnabled: true,
  mfaType: 'SMS_AND_EMAIL',
  isFirstPasswordChanged: true,
  permissions: [
    { id: 'ee695fdf-d5f2-46f6-af49-c15c4252500a', name: 'payment_transfers_list_create', type: 'CLIENT' },
    { id: 'fb76aacd-c64e-40ce-b60a-579413d8788e', name: 'transaction_transactions_pdf_read', type: 'CLIENT' },
    { id: '22e681fb-aef4-46b0-9c08-676075d97ee1', name: 'payment_international-transfers_one_create', type: 'CLIENT' },
    { id: '515102dc-9d2b-4a2a-8c1c-54f06b3dde4b', name: 'payment_recurring-payment_one_create', type: 'CLIENT' },
    { id: 'a03d7330-5208-4837-adad-1be3d35eb57f', name: 'user_accounts_pdf_read', type: 'CLIENT' },
    { id: 'fc0087f6-8de4-42b9-ad76-d3f8dd621b20', name: 'payment_transfers_internal-transfer_create', type: 'CLIENT' },
  ],
  subscriptionEndDate: null,
  duePaymentDate: null,
  isSubUser: false,
  isMain: false,
  branchCode: '0001',
  subscriptionInfo: {
    id: '5316b3de-9382-4eff-8038-8d0a1294fe6a',
    packageId: '9e751783-8068-46f4-866c-8b45c35ab930',
    billingAccountNumber: null,
    isAutoCharging: false,
    status: 'IN_PROGRESS',
    gracePeriod: 0,
  },
  packageInfo: {
    id: '9e751783-8068-46f4-866c-8b45c35ab930',
    title: 'YVANA',
    description: 'destine au ba',
    permissions: [
      { id: '22e681fb-aef4-46b0-9c08-676075d97ee1', name: 'payment_international-transfers_one_create' },
      { id: '515102dc-9d2b-4a2a-8c1c-54f06b3dde4b', name: 'payment_recurring-payment_one_create' },
      { id: 'a03d7330-5208-4837-adad-1be3d35eb57f', name: 'user_accounts_pdf_read' },
      { id: 'ee695fdf-d5f2-46f6-af49-c15c4252500a', name: 'payment_transfers_list_create' },
      { id: 'fb76aacd-c64e-40ce-b60a-579413d8788e', name: 'transaction_transactions_pdf_read' },
      { id: 'fc0087f6-8de4-42b9-ad76-d3f8dd621b20', name: 'payment_transfers_internal-transfer_create' },
    ],
    pricing: [],
    status: 'ACTIVE',
    periodicity: 'MONTHLY',
    maxNumberSubUsers: 3,
    freeOfCharge: true,
  },
  validatorsCount: null,
  language: 'fr',
  accounts: [],
  permanentRole: 'USER',
  adminRoleName: null,
  unreadAlertsCount: 0,
  avatarUrl: null,
};

// ── Settings ──────────────────────────────────────────────────────────────────

export const getSettingsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.userSettings}`, async () =>
  HttpResponse.json({
    userId: '13be585d-e25e-45fc-a244-3d566b470eb2',
    settings: {
      autoStatementGenerationEnabled: false,
      uiWidgets: {
        transactionsHistory: { enabled: true, order: 0 },
        ibTransactions: { enabled: true, order: 1 },
        recentPayments: { enabled: true, order: 2 },
        beneficiaries: { enabled: true, order: 3 },
      },
    },
  })
);

export const postSettingsHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.userSettings}`, async ({ request }) => {
  const body = await request.json().catch(() => ({}));
  return HttpResponse.json(
    {
      userId: '13be585d-e25e-45fc-a244-3d566b470eb2',
      settings: body,
    },
    { status: 202 }
  );
});

export const updateSettingsHandler = http.patch<object, any, any>(`${API_BASE_URL}${endpoints.userSettings}`, async () =>
  HttpResponse.json({ message: 'Settings updated successfully' })
);

export const changeLanguageHandler = http.patch<object, any, any>(`${API_BASE_URL}${endpoints.changeUserLanguage}`, async ({ request }) => {
  const body = await request.json().catch(() => ({}));
  return HttpResponse.json({ message: 'Language updated successfully', language: body.language || 'fr' });
});

// ── Public settings ───────────────────────────────────────────────────────────

export const getPublicSettingsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getPublicSettings}`, async () =>
  HttpResponse.json({
    contactInfo: {
      bank_phone_number: ['+211 912 442 446'],
      whatsapp_number: ['+211 922 442 446'],
      address: ['123 Bank Street, Juba'],
      facebook: ['https://facebook.com/afriland'],
      youtube: ['https://youtube.com/afriland'],
      linkedin: [''],
      instagram: [''],
      x: [''],
    },
    bankInfo: {
      bankName: 'Afriland First Bank',
      bankCode: '36035',
      bankSwiftCode: 'CCEICMCX',
      defaultCurrency: 'SSP',
      defaultLanguage: 'fr',
      aboutUrl: 'https://afrilandfirstgroup.com/index.php/en/the-group',
    },
    allowedCurrencies: ['SSP', 'USD', 'EUR'],
    supportedLanguages: ['fr', 'en'],
    branding: {
      logoUrl: 'https://example.com/logo.png',
      bannerUrl: null,
      faviconUrl: null,
      backofficeLogoUrl: null,
      backofficeFaviconUrl: null,
      colors: { primaryColor: '#E30613', secondaryColor: '#1A1A2E' },
    },
  })
);

export const getPublicAuthUserSettingsHandler = http.get<object, any, any>(
  `${API_BASE_URL}${endpoints.getPublicAuthUserSettings}`,
  async () =>
    HttpResponse.json({
      checkbookRequestRule: {
        enabled: true,
        deliveryRule: {
          authorizedDeliveryBranchCodes: ['0002', '0001', '0006'],
          deliveryBranchSelection: 'ADMIN_DEFINED',
          customAddressEnabled: true,
        },
      },
      currencyRule: {
        decimalPlaces: 4,
        localeBasedFormatting: true,
        useGroupingSeparator: true,
        showCurrencySymbol: true,
        roundingMode: 'HALF_UP',
      },
      depositRule: { enabled: false },
      financialOperationDocumentComplianceRule: {
        intraCustomer: {
          SSP: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
          USD: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
        },
        intraBranch: {
          SSP: { triggerAmount: 10, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
          USD: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
        },
        intraBank: {
          SSP: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
          USD: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
        },
        interBank: {
          SSP: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
          USD: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
        },
        swift: {
          SSP: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
          USD: { triggerAmount: 1, minRequiredDocuments: 1, maxRequiredDocuments: 1 },
        },
      },
      financialOperationDuplicateDetectionRule: {
        transfer: { enabled: false, detectionTimeWindowInSeconds: 300, includeDeferredTransfer: true },
        payment: { enabled: true, detectionTimeWindowInSeconds: 300 },
        standingOrder: { enabled: false, detectionTimeWindowInSeconds: 300 },
        tax: { enabled: true, detectionTimeWindowInSeconds: 300 },
        swift: { enabled: false, detectionTimeWindowInSeconds: 300 },
      },
      loanRule: { enabled: false },
      subUserManagementRule: {
        restrictSubUsersToCorporateOnly: true,
        subUserCanAccessAllTransactions: true,
        clientManagesSubUsers: true,
        clientManagesMainUsers: true,
        adminManagesSubUsers: true,
        adminManagesMainUsers: true,
        notifyValidatorsBySmsOnApprovalRequired: true,
        notifyValidatorsByEmailOnApprovalRequired: true,
      },
      transactionReportDownloadRule: {
        enabled: true,
        maxPeriodInDays: 10,
        allowedFormats: ['PDF'],
        maxTransactionsPerReport: 500,
        allowedRoles: ['USER', 'MAIN_SUB_USER', 'SUB_USER'],
        requiresApproval: true,
        downloadLimitPerDay: 5,
        printLimitPerDay: 5,
      },
      transferRule: {
        payment: { enableCrossCurrencyPayment: false },
        standingOrder: { enabled: true },
        swift: {
          enabled: true,
          swiftPaymentType: 'STANDARD',
          swiftConvertType: 'SWIFT_MT',
          swiftChargeBearerType: 'SENDER',
          adminApprovalRequired: true,
          swiftExecutedManually: false,
        },
        tax: { enabled: true, supportedTaxSystem: 'NRA' },
        transfer: {
          interBankTransferEnabled: true,
          deferTransferEnabled: true,
          enableCrossCurrencyTransfer: true,
          deferredTransfer: {
            minExecutionDelayInMinutes: 5,
            maxExecutionDelayInMinutes: 527040,
            smsNotificationEnabled: true,
            emailNotificationEnabled: true,
          },
        },
      },
    })
);

// ── Current user ──────────────────────────────────────────────────────────────

export const getCurrentUserHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getMe}`, async () =>
  HttpResponse.json(mockCurrentUser)
);

// ── Accounts ──────────────────────────────────────────────────────────────────

export const getAccountsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getAccounts}`, async ({ request }) => {
  const auth = request.headers.get('Authorization') ?? '';
  const isSspUser = auth.includes('ssp_signature');
  return HttpResponse.json({ userAccounts: isSspUser ? mockSspAccounts : mockAccounts });
});

// ── Exchange rates ────────────────────────────────────────────────────────────

export const getExchangeRatesHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getExchangeRates}`, async () =>
  HttpResponse.json({
    exchangeRates: [
      {
        sourceCurrency: 'EUR',
        targetCurrency: 'SSP',
        buyingRate: 62,
        sellingRate: 64,
        effectiveDate: '2011-07-05',
      },
      {
        sourceCurrency: 'USD',
        targetCurrency: 'SSP',
        buyingRate: 4593.12,
        sellingRate: 4593.12,
        effectiveDate: '2025-10-17',
      },
      {
        sourceCurrency: 'GBP',
        targetCurrency: 'SSP',
        buyingRate: 99,
        sellingRate: 116,
        effectiveDate: '2011-06-14',
      },
      {
        sourceCurrency: 'SSP',
        targetCurrency: 'SSP',
        buyingRate: 1,
        sellingRate: 1,
        effectiveDate: '2026-04-08',
      },
    ],
  })
);

// ── Bank info (currencies, banks, branches) ───────────────────────────────────

export const getBankInfoHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getDataDetails}`, async () =>
  HttpResponse.json({
    currencies: [
      { id: '2d0a7522-7e01-44ae-b387-3033bafd5cf5', alphabeticCode: 'USD' },
      { id: '23bef168-362c-4f94-b37e-b0f7c4adc455', alphabeticCode: 'SSP' },
      { id: 'eur-id', alphabeticCode: 'EUR' },
    ],
    banks: [
      { id: '5eb3214a-34a6-4b5e-bc57-0861eca72c50', bankCode: '36035', name: 'AFRILAND FIRST BANK' },
      { id: 'bank-ext-01', bankCode: '10001', name: 'EXTERNAL BANK ONE' },
    ],
    countries: [
      { id: 'a815b721-cfa3-4e84-b13f-9ff399bdb240', name: 'Cameroon', code: 'CM' },
      { id: 'ss-id', name: 'South Sudan', code: 'SS' },
    ],
    beneficiaries: [],
    // IB1-mock : `normalizeCheckbookTypes` (src/features/data/dataSlice.ts) lit `label` (pas `name`)
    // et `chTypes()` (CheckbookManagement) filtre ensuite par `currency` (code alpha du compte
    // sélectionné) — il faut donc au moins une entrée par devise mockée ci-dessus (USD/SSP/EUR)
    // pour que le dropdown "Checkbook Type" ne soit jamais vide quelle que soit la devise du compte.
    checkbookTypes: [
      { id: 'chk-usd-standard', code: 'STD-USD', label: 'Standard Checkbook', currency: 'USD', numberOfLeaves: 25, fee: 5000 },
      { id: 'chk-usd-business', code: 'BUS-USD', label: 'Business Checkbook', currency: 'USD', numberOfLeaves: 50, fee: 10000 },
      { id: 'chk-ssp-standard', code: 'STD-SSP', label: 'Standard Checkbook', currency: 'SSP', numberOfLeaves: 25, fee: 5000 },
      { id: 'chk-eur-business', code: 'BUS-EUR', label: 'Business Checkbook', currency: 'EUR', numberOfLeaves: 50, fee: 45 },
    ],
    swiftCurrencies: [{ code: 'USD' }, { code: 'EUR' }],
    branches: [
      { id: 'br-0001', branchCode: '0001', name: 'Main Branch', bank: { bankCode: '36035' } },
      { id: 'br-0002', branchCode: '0002', name: 'Branch 2', bank: { bankCode: '36035' } },
      { id: 'br-ext-01', branchCode: '1001', name: 'Ext Branch 1', bank: { bankCode: '10001' } },
    ],
    periodicities: ['DAILY', 'WEEKLY', 'MONTHLY'],
  })
);

// ── Terms and conditions ──────────────────────────────────────────────────────

export const getPublishedTermsAndConditionsHandler = http.get<object, any, any>(
  `${API_BASE_URL}${endpoints.getPublishedTermsAndConditions}`,
  async () =>
    HttpResponse.json({
      id: 'terms-v1',
      version: '15.0.0',
      publishedAt: '2024-01-01T00:00:00Z',
      effectiveDate: '2024-01-01T00:00:00Z',
      termsAndConditionContents: [
        { language: 'FR', content: 'Contenu des conditions générales' },
        { language: 'EN', content: 'Terms and conditions content' },
        { language: 'PT', content: 'Conteúdo dos termos e condições' },
      ],
    })
);

export const acceptTermsAndConditionsHandler = http.post<object, any, any>(
  `${API_BASE_URL}${endpoints.acceptTermsAndConditions}`,
  async () => HttpResponse.json({ message: 'Terms accepted' })
);

// ── CBS health check ──────────────────────────────────────────────────────────

export const getCbsStateHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getCbsState}`, async () =>
  HttpResponse.json({ status: 'UP' })
);

// ── Beneficiaries ─────────────────────────────────────────────────────────────

export const getBeneficiariesHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getBeneficiaries}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: '5ac5d4bc-606e-423a-96f5-2b127d6040e6',
        name: 'YVES NARCISSE FEUGWO FEUKOUO',
        bank: { id: '5eb3214a-34a6-4b5e-bc57-0861eca72c50', name: 'AFRILAND FIRST BANK', bankCode: '36035' },
        branchCode: '0001',
        phone: '+211921575076',
        email: 'yves@example.com',
        country: { id: 'a815b721-cfa3-4e84-b13f-9ff399bdb240', name: 'Cameroon', code: 'CM' },
        town: null,
        address: null,
        zipCode: null,
        accountNumber: '00010779406-11',
        type: 'USER',
        iban: null,
        swift: null,
        currency: { id: '23bef168-362c-4f94-b37e-b0f7c4adc455', alphabeticCode: 'SSP' },
      },
      {
        id: 'ben-002',
        name: 'JEAN PAUL DUPONT',
        bank: { id: 'bank-ext-01', name: 'EXTERNAL BANK ONE', bankCode: '10001' },
        branchCode: '1001',
        phone: '+237699000001',
        email: 'jean@example.com',
        country: { id: 'ss-id', name: 'South Sudan', code: 'SS' },
        town: 'Juba',
        address: '12 Main St',
        zipCode: null,
        accountNumber: '00010779406-22',
        type: 'USER',
        iban: null,
        swift: null,
        currency: { id: '2d0a7522-7e01-44ae-b387-3033bafd5cf5', alphabeticCode: 'USD' },
      },
    ],
    first: true,
    last: true,
    totalPages: 1,
    totalElements: 2,
    numberOfElements: 2,
    size: 5,
    number: 0,
    sort: 'name:DESC;name:ASC',
  })
);

// ── Recent payments ───────────────────────────────────────────────────────────

export const getRecentPaymentsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.recentPayments}`, async () =>
  HttpResponse.json({
    payments: [
      {
        id: 'pay-001',
        amount: 500,
        currency: { alphabeticCode: 'USD' },
        reason: 'Invoice #1234',
        status: 'COMPLETED',
        createdAt: '2026-04-01T10:00:00Z',
        beneficiary: { name: 'YVES NARCISSE FEUGWO FEUKOUO', accountNumber: '00010779406-11' },
      },
      {
        id: 'pay-002',
        amount: 1200,
        currency: { alphabeticCode: 'SSP' },
        reason: 'Rent March',
        status: 'COMPLETED',
        createdAt: '2026-03-28T09:30:00Z',
        beneficiary: { name: 'JEAN PAUL DUPONT', accountNumber: '00010779406-22' },
      },
    ],
  })
);

// ── Transactions ──────────────────────────────────────────────────────────────

export const getTransactionsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getTransactions}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: 'tx-001',
        accountingDate: '2026-04-05T08:00:00Z',
        amount: 500,
        currency: { alphabeticCode: 'USD' },
        type: 'DEBIT',
        reason: 'Transfer to YVES',
        status: 'COMPLETED',
        accountId: '0b679eab-db5e-4cb4-b07e-2a8185bb2757',
      },
      {
        id: 'tx-002',
        accountingDate: '2026-04-03T14:00:00Z',
        amount: 2000,
        currency: { alphabeticCode: 'USD' },
        type: 'CREDIT',
        reason: 'Client payment',
        status: 'COMPLETED',
        accountId: '0b679eab-db5e-4cb4-b07e-2a8185bb2757',
      },
    ],
    number: 0,
    numberOfElements: 2,
    totalElements: 2,
    totalPages: 1,
    size: 40,
    sort: 'accountingDate:DESC;id:ASC',
    total: {
      totalIncome: 2000,
      totalExpenses: 500,
    },
  })
);

// ── Pending transactions (financial operations histories) ─────────────────────

export const getPendingTransactionsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getPendingTransactions}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: 'pending-001',
        amount: 300,
        currency: { alphabeticCode: 'USD' },
        status: 'PENDING',
        type: 'TRANSFER',
        createdAt: '2026-04-07T11:00:00Z',
        beneficiaryName: 'JEAN PAUL DUPONT',
        accountNumber: '00010779406-22',
      },
    ],
    number: 0,
    numberOfElements: 1,
    totalElements: 1,
    totalPages: 1,
    size: 20,
    sort: [{ property: 'transactionDate', direction: 'DESC', ignoreCase: false }],
  })
);

// ── Alerts ────────────────────────────────────────────────────────────────────

export const getAlertsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getAlerts}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: 'alert-001',
        type: 'INFO',
        message: 'Your transfer has been processed',
        read: false,
        createdAt: '2026-04-08T09:00:00Z',
      },
    ],
    total: 1,
  })
);

// ── MFA / TOTP ────────────────────────────────────────────────────────────────

export const getMFAStatusHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getTotpStatus}`, async () =>
  HttpResponse.json({ enabled: false, backup_codes_count: 0 })
);

// ── Sessions ──────────────────────────────────────────────────────────────────

export const getSessionsHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getSesions}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: 'session-001',
        device: 'Chrome / Linux',
        ip: '192.168.1.1',
        createdAt: '2026-04-08T08:00:00Z',
        current: true,
      },
    ],
    total: 1,
  })
);

export const updateAccountNameHandler = http.put<{ id: string }, any, any>(
  `${API_BASE_URL}${endpoints.getAccounts}/:id/name`,
  async ({ request }) => {
    const body = await request.json().catch(() => ({}));
    return HttpResponse.json({ ...mockAccounts[0], name: body.name });
  }
);

export const updateAccountDisplayingHandler = http.put<object, any, any>(`${API_BASE_URL}${endpoints.getAccounts}`, async () =>
  HttpResponse.json({ message: 'Updated' })
);

export const userHandlers = [
  getSettingsHandler,
  postSettingsHandler,
  updateSettingsHandler,
  changeLanguageHandler,
  getPublicSettingsHandler,
  getPublicAuthUserSettingsHandler,
  getCurrentUserHandler,
  getAccountsHandler,
  getExchangeRatesHandler,
  getBankInfoHandler,
  getPublishedTermsAndConditionsHandler,
  acceptTermsAndConditionsHandler,
  getCbsStateHandler,
  getBeneficiariesHandler,
  getRecentPaymentsHandler,
  getTransactionsHandler,
  getPendingTransactionsHandler,
  getAlertsHandler,
  getMFAStatusHandler,
  getSessionsHandler,
  updateAccountNameHandler,
  updateAccountDisplayingHandler,
];
